module.exports = __webpack_public_path__ + "static/img/zzc_3.715421c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_3.png
// module id = nZKL
// module chunks = 19